import React from "react";

export const ReportValues = ({ strategy }) => {
  const values = strategy.brand_values || {};
  return (
    <div className="space-y-6">
      <div className="bg-slate-900/50 border border-slate-800 rounded-2xl p-6">
        <h3 className="font-semibold text-emerald-400 mb-2">Mission Statement</h3>
        <p className="text-white text-lg">{values.brand_mission || "N/A"}</p>
      </div>
      <div className="bg-slate-900/50 border border-slate-800 rounded-2xl p-6">
        <h3 className="font-semibold text-emerald-400 mb-2">Vision Statement</h3>
        <p className="text-white text-lg">{values.brand_vision || "N/A"}</p>
      </div>
      {values.core_values && (
        <div className="bg-slate-900/50 border border-slate-800 rounded-2xl p-6">
          <h3 className="font-semibold text-white mb-4">Core Values</h3>
          <div className="space-y-4">
            {values.core_values.map((val, i) => {
              const label = typeof val === "object" ? val.value : val;
              return (
                <div key={`value-${label}-${i}`} className="p-4 bg-slate-800/50 rounded-xl">
                  <h4 className="font-semibold text-emerald-400 mb-1">{label}</h4>
                  {typeof val === "object" && val.description && (
                    <p className="text-slate-300 text-sm">{val.description}</p>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
};
